import Vue from 'vue';

const success = (response, resolve) => {
  resolve(response);
};

const failed = (error, reject) => {
  reject(error);
};

export default data => (
  new Promise((resolve, reject) => {
    Vue.$http.post(`/google_two_factor_auth/${data.user_id}/verify_token`, data)
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/googleTwoFactorAuthSetup/verifyToken.js